export const login = () => {
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  window.location.assign(`${REACT_APP_BACKEND_URL}/auth/github`);
  return;
};
